import { render, staticRenderFns } from "./job-status.vue?vue&type=template&id=be048d7c&"
import script from "./job-status.vue?vue&type=script&lang=js&"
export * from "./job-status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports